import React from 'react'

import CustomHelmet from '../../components/CustomHelmet'
import Hero from '../../components/ProgramOverview/Hero'
import Apply from '../../components/Apply'
import Helmet from 'react-helmet'
import Fellows from '../../components/Fellows'
import Row from '../../components/Shared/Row'
import Column from '../../components/Shared/Column'
import BioCard from '../../components/BioCard'
import BioTray from '../../components/BioTray'


class Speakers extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            teamTray: false,
            activeProfile: null,
        }

        // this.speakerStaff = this.sort(this.props.data.speakerProfiles.edges)
        this.moderatorStaff = this.sort(this.props.data.moderatorProfiles.edges)
        this.academySpeakersActiveList = this.sort(this.props.data.allTimeSpeakerProfiles.edges)

    }

    sort( staff ) {
        // alphabetize by first name
        if (staff.length > 0) {
            return staff.sort( (a, b) => {
                if(a.node.name < b.node.name) return -1
                if(a.node.name > b.node.name) return 1
                return 0
            })
        }
    }

    setActiveStaff(profile, e) {
        document.body.parentNode.classList.add('freeze')
        this.setState({ teamTray: true, activeProfile: profile })
    }

    unsetActiveStaff() {
        document.body.parentNode.classList.remove('freeze')
        this.setState({ teamTray: false, activeProfile:null })
    }

    componentWillUnmount() {
        this.unsetActiveStaff()
    }

    render() {
        const { data: { speakerProfiles, moderatorProfiles }} = this.props

        const temporarySEOData = {
            keywords: null,
            openGraphDescription: {
                openGraphDescription: "Leadership in Action Speakers | Global Citizen Academy",
            },
            openGraphImage: null,
            openGraphTitle: "Leadership in Action Speakers | Global Citizen Academy",
            pageDescription: {
                pageDescription: "Leadership in Action Speakers"
            },
            pageTitle: "Leadership in Action Speakers | Global Citizen Academy"
        }

        return (
          <div className="page-team page-speakers" style={{ margin: '0 auto'}}>
            <CustomHelmet data={ temporarySEOData } />
            <Hero title="SPEAKER SERIES:<br/>LEADERSHIP IN ACTION" />
            <div className="cards-super-wrap">
                <Row className="capper impact-cards-wrapper">
                    <Column className="impact-header" width="12">
                        <h3 className="text-center">The Academy speaker series puts today's most impactful leaders in conversation with Global Citizen Year students — the rising leaders of tomorrow. As these influential changemakers share their leadership journeys, students gain valuable insights on overcoming challenges, learning from mistakes, staying true to their values, and committing to continual growth.<br/>
                        <br/>Unlike traditional lectures or TEDtalks, these deeply human conversations are live, unscripted and student-led, featuring alumni moderators and questions from Academy students.<br/>
                        <br/>Here you'll find a complete list of past and present Academy speakers.</h3>
                    </Column>
                </Row>
                <Row className="impact-cards-wrapper capper no-top-padding">
                    <h2 className="h2 text-center">Academy Speakers</h2>
                </Row>
                <Row className="capper impact-cards-wrapper no-top-padding">
                    { this.academySpeakersActiveList.length > 0 &&
                        <Row className="no-padding">
                            { this.academySpeakersActiveList.map( (staff, index) => (
                                <Column key={ index } width="3" tablet="4" mobile="6">
                                    <span onClick={ () => this.setActiveStaff(staff.node) }>
                                        <BioCard data={ staff.node } />
                                    </span>
                                </Column>
                            ))}
                        </Row>
                    }
                </Row>
                <Row className="capper impact-cards-wrapper no-top-padding no-bottom-padding">
                    <h2 className="h2 text-center">Alumni Moderators</h2>
                </Row>
                <Row className="capper impact-cards-wrapper no-top-padding">
                    { this.moderatorStaff.length > 0 &&
                        <Row className="no-padding">
                            { this.moderatorStaff.map( (staff, index) => (
                                <Column key={ index } width="3" tablet="4" mobile="6">
                                    <span onClick={ () => this.setActiveStaff(staff.node) }>
                                        <BioCard data={ staff.node } />
                                    </span>
                                </Column>
                            ))}
                        </Row>
                    }
                </Row>
                <img className="green-brush-team" src="/images/green-strokes.png" alt="green brush strokes" />
            </div>

            <BioTray teamTray={ this.state.teamTray }
                     activeProfile={ this.state.activeProfile }
                     setActiveFellow={ () => this.setActiveStaff() }
                     unsetActiveFellow={ () => this.unsetActiveStaff() }
                     noLink />
          </div>
    )
  }
}

export default Speakers

export const query = graphql`
query SpeakerStagePageQuery  {
   allTimeSpeakerProfiles:allContentfulStaffProfile(filter:{team:{title:{eq:"Academy Speakers: ALL TIME"}}}){
   edges  {
     node {
       name
       title
       featured
       image {
         resize(width:320, height:320) {
           src
         }
       }
       bio {
         bio
       }
       team {
         title
       }
     }
    }
  }
   moderatorProfiles:allContentfulStaffProfile(filter:{team:{title:{eq:"Alumni Moderator"}}}){
   edges  {
     node {
       name
       title
       image {
         resize(width:320, height:320) {
           src
         }
       }
       bio {
         bio
       }
       team {
         title
       }
     }
    }
  }
}
`;



// WEBPACK FOOTER //
// ./src/pages/academy/speakers.js